// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
export type PublicSecurityTypeFragment = { __typename?: 'PublicSecurityTypeDTO', countryCode: string, id: number, printable: boolean, printableBlank: boolean, receipt: boolean, sendFile: boolean, sendOnline: boolean, type: Types.PublicSecurityTypeEnum };

export const PublicSecurityTypeFragment = gql`
    fragment PublicSecurityType on PublicSecurityTypeDTO {
  countryCode
  id
  printable
  printableBlank
  receipt
  sendFile
  sendOnline
  type
}
    `;
/* eslint-enable */